import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
  standalone: true,
  selector: 'app-table-header',
  templateUrl: './table-header.component.html',
  styleUrls: ['./table-header.component.less']
})
export class TableHeaderComponent {
  @Input() showInfos: boolean = true;
  @Input() itensNumber: number = 0;
  @Input() totalNumber: number = 0;
  @Input() hasCSV: boolean = false;
  @Input() hasPDF: boolean = false;
  @Input() loadingData$: any;
  @Output() downloadCSV = new EventEmitter<boolean>();
  @Output() downloadPDF = new EventEmitter<boolean>();

  constructor() { }

  exportCSV() {
    this.downloadCSV.emit(true);
  }

  exportPDF() {
    this.downloadPDF.emit(true);
  }
}
